export default function asMailtoHref(querydb, program, numQueries, url, isOpenAccess) {
  var dbsArr = formatDatabases(querydb);
  var mailto = composeEmail(dbsArr, program, numQueries, url, isOpenAccess);
  return encodeEmail(mailto);
}
function formatDatabases(querydb) {
  return querydb ? querydb.slice(0, 15).map(function (db) {
    return ' ' + db.title;
  }) : "";
}
function composeEmail(dbsArr, program, numQueries, url, isOpenAccess) {
  var upperProgram = program.toUpperCase();
  var accessStatement = isOpenAccess ? '' : 'The link will work if you have access to that particular SequenceServer instance.';
  return "mailto:?subject=SequenceServer ".concat(upperProgram, " analysis results &body=Hello,\n\n        Here is a link to my recent ").concat(upperProgram, " analysis of ").concat(numQueries, " sequences.\n            ").concat(url, "\n\n        The following databases were used (up to 15 are shown):\n            ").concat(dbsArr, "\n\n        ").concat(accessStatement, "\n\n        Thank you for using SequenceServer, and please remember to cite our paper.\n\n        Best regards,\n\n        https://sequenceserver.com");
}
function encodeEmail(mailto) {
  return encodeURI(mailto).replace(/(%20){2,}/g, '');
}